
import { useQuasar } from 'quasar'
import { computed, defineComponent, nextTick, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { UserModel } from '@/models/auth'
import DButton from '@/components/base/DButton.vue'
import CloseIcon from '@/components/Icons/CloseIcon.vue'
import PenIcon from '@/components/Icons/PenIcon.vue'
import DButtonToggle from '@/components/base/DButtonToggle.vue'
import PictureDrop from '@/pages/NewSettings/components/ManageUsers/PictureDrop.vue'

export default defineComponent({
  name: 'ProfilePicture',
  props: {
    src: {
      type: String,
      required: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    fullSize: {
      type: Boolean,
      default: false
    }
  },
  components: { PictureDrop, DButtonToggle, PenIcon, CloseIcon, DButton },
  emits: ['update:src', 'update:editing'],
  setup (props, { emit }) {
    const $q = useQuasar()
    const $store = useStore()
    const $sys = $store.getters['Services/Sys']
    const showModal = ref(false)
    const initialSrc = ref(props.src)
    const uploadedPicture = ref('')



    const avatars = [
      require('@/assets/avatars/avatar-1.png'),
      require('@/assets/avatars/avatar-2.png'),
      require('@/assets/avatars/avatar-3.png'),
      require('@/assets/avatars/avatar-4.png'),
      require('@/assets/avatars/avatar-5.png'),
      require('@/assets/avatars/avatar-6.svg'),
      require('@/assets/avatars/avatar-7.svg'),
      require('@/assets/avatars/avatar-8.svg'),
      require('@/assets/avatars/avatar-9.svg'),
      require('@/assets/avatars/avatar-11.png'),
      require('@/assets/avatars/avatar-10.svg'),
    ]

    const urlToBase64 = (url) => {
      return new Promise(function (resolve, reject) {
        const xhr = new XMLHttpRequest()
        xhr.onload = function () {
          const reader = new FileReader()
          reader.onloadend = function () {
            resolve(reader.result)
          }
          reader.onerror = reject
          reader.readAsDataURL(xhr.response)
        }
        xhr.onerror = reject
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.send()
      })
    }

    const onFileReceived = (event) => {
      if (event?.file) {
        emit('update:src', event.file)
        uploadedPicture.value = event.file
      }
    }


    const onUploadCleared = () => {
      emit('update:src', initialSrc.value)
      uploadedPicture.value = ''
    }

    const updateAvatar = async (avatarUrl) => {
      if (!props.editing) {
        emit('update:editing', true)
        await nextTick()
      }

      emit('update:src', await urlToBase64(avatarUrl))

      showModal.value = false
    }

    return {
      avatars,
      updateAvatar,
      showModal,
      onFileReceived,
      initialSrc,
      uploadedPicture,
      onUploadCleared
    }
  }
})
